import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "confirm-button-component flex w-full" }
const _hoisted_2 = {
  ref: "dialog",
  class: "rounded-lg p-6 max-w-sm w-full shadow-lg"
}
const _hoisted_3 = { class: "text-gray-800 mb-4" }
const _hoisted_4 = { class: "flex justify-end space-x-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_basic_button = _resolveComponent("basic_button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_basic_button, {
      onClick: _cache[0] || (_cache[0] = $event => ($setup.open_confirmarion_modal())),
      disabled: $setup.prop_disabled || $setup.dat_paused,
      size: $setup.prop_size,
      error: ""
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["disabled", "size"]),
    _createElementVNode("dialog", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "confirmation_text")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_basic_button, {
          disabled: false,
          size: 'small',
          onClick: _cache[1] || (_cache[1] = $event => ($setup.cancel()))
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" No ")
          ])),
          _: 1 /* STABLE */,
          __: [3]
        }),
        _createVNode(_component_basic_button, {
          error: "",
          disabled: false,
          size: 'small',
          onClick: _cache[2] || (_cache[2] = $event => ($setup.clicked($event)))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" Yes ")
          ])),
          _: 1 /* STABLE */,
          __: [4]
        })
      ])
    ], 512 /* NEED_PATCH */)
  ]))
}